// eslint-disable-next-line import/prefer-default-export
export enum LicenseType {
  BOX = 'box',
  NO_BOX = 'noBox',
}
